module.exports = __webpack_public_path__ + "static/img/7.4e92407.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/7.png
// module id = O/xQ
// module chunks = 0